export const getTimestampToDate = (timeStamp: number): string => {
    const date = new Date(timeStamp * 1000);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};